<template>
  <client-click-events-modal
    :brand="brand"
    :product="productTitle"
    :url="url"
    :clicks="clickEvents"
    :loading="eventsLoading"
    @closed="onClosed"
  />
</template>
<script>
import ClientClickEventsModal from '@/components/Widgets/ClientHistory/ClientClickEventsModal';
import { CLICK } from '@/_store/events.module.js';

export default {

  name: 'ClientClickEventsModalContainer',
  components: { ClientClickEventsModal },
  props: {
    url: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    outreachId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    clickEvents() {
      // Should always be only click events, and for the same url
      return this.$store.state.events.filteredItems;
    },
    eventsLoading() {
      return this.$store.state.events.filteredLoading;
    },
    productTitle() {
      if (!this.clickEvents.length || !this.clickEvents[0].product) return '';
      return this.clickEvents[0].product.title;
    },
    brand() {
      if (!this.clickEvents.length || !this.clickEvents[0].product) return '';
      return this.clickEvents[0].product.brand.name;
    },
  },
  mounted() {
    this.fetchClickEvents();
  },
  methods: {
    fetchClickEvents() {
      if (!this.url || !this.count) {
        console.log('Missing data for retrieval', this.url, this.count);
        return;
      }
      this.$store.dispatch('events/fetchFiltered', {
        outreach: this.outreachId,
        event: CLICK,
        url: this.url,
        page_size: this.count,
      });
    },
    onClosed() {
      this.$store.commit('events/updateFiltered', []);
      this.$emit('closed');
    },
  },
};
</script>
<style lang="css"
  scoped>
</style>
